import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  noProfileContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  NoProfileContainer: {
    height: '100%',
    display: 'flex',
    alignItems: 'center'
  },
  textWrap: {
    textAlign: 'center'
  },
  semiBoldText: {
    fontWeight: '500',
    fontSize: 20,
    marginBottom: '1rem'
  },
  normalText: {
    marginBottom: '4rem',
    fontSize: 20,
  },
  tryAgainBtn: {
    margin: '4rem 0 2rem 0'
  }
}));
